import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import { insightsViewModel } from '../views/dashboard/insights.view.model';
import ComplimentIcon from '../../assets/images/Compliment-icon.svg';
import "./binkiesCompliments.css";
import ReactTimeAgo from 'react-time-ago';
import { COMPLIMENTS_GIVEN, COMPLIMENTS_RECEIVED, SHARE_CREATION_ROUTE_BANNER } from '../../constants/routes.constants';
import { useHistory } from 'react-router-dom';
import { Skeleton } from '@mui/material';
import { getUserTypeBadge } from '../../utils/utils';
import IIcon from '../../assets/icon/PRINT.svg';
import NoComplimentsReceivedImg from '../../assets/images/tour/no-compliments-received.svg';
import NoComplimentsGivenImg from '../../assets/images/tour/no-compliments-given.svg';
import { Image } from 'react-bootstrap';
import CampNoDataTooltip from '../views/school/camp_tour/CampNoDataTooltip';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
    padding: theme.spacing(2),
    boxShadow: 'none',
  },
  card: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1),
    borderRadius: 8,
    boxShadow: 'none',
    padding: '0px 19px',
  },
  avatar: {
    marginRight: theme.spacing(2),
    cursor: 'pointer',
    borderRadius: '10px !important',
  },
  content: {
    flex: '1 0 auto',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    padding: '0px 7px',
  },
  icon: {
    marginRight: '21px',
    paddingLeft: '15px',
  },
}));

const commentColors = [
  '#ffd29f',
  '#C0FECF',
  '#F2F6AB',
  '#D6D5FD',
  '#B3E5FE',
  '#9CF2F1',
  '#FDE988',
  '#ffd6fa',
  '#d6fbff',
  '#ddd6ff',
];

const ComplimentsReceived = ({ type, dependent, cardClass }) => {
  const _PAGE_LIMIT = 3;
  const classes = useStyles();
  const history = useHistory();
  const [compliments, setCompliments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showNoDataTooltip, setShowNoDataTooltip] = useState(false);
  const [tooltipData, setTooltipData] = useState([]);

  const NoComplimentReceived = [
    {
      element: '#no-compliments-Received',
      intro: `
      <div class="custom-tour-step">
        <img src="${NoComplimentsReceivedImg}" alt="Camp Master" class="tour-avatar" />
        <h3>Compliments Received</h3>
        <p>Compliments Received' displays the total number of compliments your child’s creations have gathered from others. It's a great way to track how much their work is appreciated by the community. The more compliments they receive, the more their creativity and effort are recognized!</p>
      </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip', // Custom tooltip class for CSS
      highlightClass: 'custom-highlight', // Custom highlight class for step highlighting
    },
  ];

  const NoComplimentGiven = [
    {
      element: '#no-compliments-Given',
      intro: `
      <div class="custom-tour-step">
        <img src="${NoComplimentsGivenImg}" alt="Camp Master" class="tour-avatar" />
        <h3>Compliments Given</h3>
        <p>Compliments Given' tracks the total number of compliments they have shared with others. This feature encourages a positive and supportive community by highlighting your engagement with fellow creators. By giving compliments, they contribute to an environment where kindness is celebrated and recognized!</p>
      </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip', // Custom tooltip class for CSS
      highlightClass: 'custom-highlight', // Custom highlight class for step highlighting
    },
  ];

  const getComplimentsReceived = () => {
    const API =
      type === 'Received'
        ? insightsViewModel.dependentReceivedComments
        : insightsViewModel.dependentGivenComments;
    setCompliments([]); // Clear the state before fetching new data
    const list = [];
    let query = {
      limit: _PAGE_LIMIT,
      has_more: true,
      dependent_id: dependent.id,
    };
    API(query, list)
      .then((res) => {
        setCompliments(
          res.commentList.map((item, i) => {
            const colorIndex = i % 10;
            item.colorIndex = colorIndex;
            return item;
          })
        );
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    setCompliments([]);
    getComplimentsReceived();
  }, [dependent]);

  const handleSeeAllClick = () => {
    history.push({
      pathname: type === 'Received' ? COMPLIMENTS_RECEIVED : COMPLIMENTS_GIVEN,
      state: {
        dependent: JSON.stringify(dependent),
        type: type,
      },
    });
  };

  const onRedirect = (user) => {
    if (user.user_type === 'dependent') history.push(`/${user.username}`);
  };

  const onArtClick = (creationId) => {
    const encoded = btoa(`{"id":${creationId}, "slug":"creation"}`);
    history.push({
      pathname: SHARE_CREATION_ROUTE_BANNER,
      search: `?encrypt=${encoded}`,
    });
  };

  const handleNoDataClick = () => {
    if (type === 'Received') {
      setTooltipData(NoComplimentReceived);
    } else {
      setTooltipData(NoComplimentGiven);
    }
    setShowNoDataTooltip(true);
  };

  return loading ? (
    <Box className={classes.root}>
      <Box className={classes.header}>
        <Typography variant="h6" className="compliments-received">
          <img src={ComplimentIcon} alt="Compliment Icon" />
          Compliments {type}
        </Typography>
      </Box>
      <Divider />
      <Skeleton variant="rectangular" width="100%" height={70} />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={70}
        style={{ marginTop: 16 }}
      />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={70}
        style={{ marginTop: 16 }}
      />
    </Box>
  ) : (
    <Box className={`${classes.root} ${cardClass}`}>
      <CampNoDataTooltip
        showTooltip={showNoDataTooltip}
        setShowTooltip={setShowNoDataTooltip}
        step={tooltipData}
      />
      <Box className={classes.header}>
        <Typography variant="h6" className="compliments-received">
          <img
            src={ComplimentIcon}
            className={classes.icon}
            alt="Compliment Icon"
          />
          Compliments {type}
        </Typography>
        {compliments.length > 0 && (
          <Typography
            onClick={handleSeeAllClick}
            style={{ cursor: 'pointer', marginRight: '10px' }}
            variant="body2"
            color="primary"
            className="insights-see-all-text"
          >
            See All
          </Typography>
        )}
      </Box>
      {compliments.length > 0 ? (
        compliments.map((compliment, index) => (
          <div key={index}>
            <Divider />
            <Card className={classes.card}>
              <Avatar
                src={compliment?.creation?.media[0]?.url}
                alt="Avatar"
                className={classes.avatar}
                onClick={() => onArtClick(compliment?.creation?.id)}
              />
              <CardContent className={classes.content}>
                <Typography variant="body2" color="textSecondary">
                  {type === 'Received' ? 'From' : 'To'}:{' '}
                  {type === 'Given' ? (
                    <Link
                      onClick={() => onRedirect(compliment?.creation?.user)}
                    >
                      {compliment?.creation?.user?.username}
                    </Link>
                  ) : (
                    <Link onClick={() => onRedirect(compliment?.user)}>
                      {compliment?.user?.user_type === 'dependent'
                        ? compliment?.user?.username
                        : `${compliment?.user?.first_name} ${compliment?.user?.last_name}`}
                    </Link>
                  )}
                  <span
                    className="message-wrapper"
                    style={{
                      backgroundColor: commentColors[compliment.colorIndex],
                    }}
                  >
                    {compliment.text}
                  </span>
                </Typography>
                <Typography>
                  {compliment?.user?.user_type === 'school_teacher' ||
                  compliment?.user?.user_type === 'school' ||
                  compliment?.user?.user_type === 'camp master' ||
                  compliment?.user?.user_type === 'partner' ? (
                    <button className="blue-admin-button">
                      {getUserTypeBadge(compliment?.user?.user_type)}
                    </button>
                  ) : (
                    ''
                  )}
                </Typography>
                <Typography
                  className="time-compliments"
                  variant="caption"
                  color="textSecondary"
                >
                  <ReactTimeAgo date={compliment?.created_at} />
                </Typography>
              </CardContent>
            </Card>
          </div>
        ))
      ) : (
        <React.Fragment>
          <Divider />
          <div
            className="insights-text no-data-found"
            id={`no-compliments-${type}`}
          >
            <div className="text-wrapper">
              <Image
                src={IIcon}
                alt="no-data"
                className="add-pointer"
                onClick={handleNoDataClick}
              />
              <Typography variant="body1">
                No compliments {type.toLowerCase()} at this time.
              </Typography>
            </div>
          </div>
        </React.Fragment>
      )}
    </Box>
  );
};

export default ComplimentsReceived;
